import 'SF/dashboard/GridPanel.js';
import 'SF/dashboard/data/CoursesStore.js';
import 'SF/dashboard/data/MyMessagesStore.js';
import 'SF/dashboard/data/RecentChangeStore.js';
import 'SF/dashboard/data/ServiceStore.js';
import 'SF/dashboard/data/StudentAttributesStore.js';
import 'SF/dashboard/data/StudentSuccessScoresStore.js';
import 'SF/dashboard/data/SuccessNetworkStore.js';
import 'SF/dashboard/data/TrackingStore.js';
import 'SF/dashboard/data/UpcomingTasksStore.js';
import 'SF/degreeplanner/AGIframePanel.js';
import 'SF/dashboard/student/AGPlansPanel.js';
import 'SF/dashboard/student/CourseCard.js';
import 'SF/dashboard/student/CoursesImTakingPanel.js';
import 'SF/dashboard/student/FilterModel.js';
import 'SF/dashboard/student/MyMessagesPanel.js';
import 'SF/dashboard/student/MySuccessNetworkPanel.js';
import 'SF/dashboard/student/MySuccessPathPanel.js';
import 'SF/dashboard/student/Portal.js';
import 'SF/dashboard/student/StaffDashboardPanel.js';
import 'SF/dashboard/student/StudentHelpPanel.js';
import 'SF/dashboard/student/StudentToDoPanel.js';
import 'SF/dashboard/student/StudentUpcomingTasksPanel.js';
import 'SF/dashboard/student/StudyGroup/JoinActionPanel.js';
import 'SF/dashboard/student/StudyGroup/JoinGridPanel.js';
import 'SF/dashboard/student/StudyGroup/JoinWindow.js';
import 'SF/dashboard/student/agenda/AgendaPanel.js';
import 'SF/dashboard/student/agenda/KudosPanel.js';
import 'SF/dashboard/student/agenda/ScheduledPanel.js';
import 'SF/dashboard/student/agenda/UnscheduledPanel.js';
import 'SF/dashboard/student/agenda/data/AgendaStore.js';
import 'SF/dashboard/student/agenda/data/InterventionStore.js';
import 'SF/dashboard/student/agenda/data/KudosStore.js';
import 'SF/dashboard/student/course/AgendaPanel.js';
import 'SF/dashboard/student/course/AttendancePanel.js';
import 'SF/dashboard/student/course/Card.js';
import 'SF/dashboard/student/course/GradePanel.js';
import 'SF/dashboard/student/course/GradesChart.js';
import 'SF/dashboard/student/course/GradesGridPanel.js';
import 'SF/dashboard/student/course/KudosPanel.js';
import 'SF/dashboard/student/course/NetworkPanel.js';
import 'SF/dashboard/student/course/PastItemsPanel.js';
import 'SF/dashboard/student/course/data/GradeAverageStore.js';
import 'SF/dashboard/student/course/data/GradeStore.js';
import 'SF/dashboard/student/help/StudentHelpForm.js';
import 'SF/dashboard/student/help/StudentHelpInlineForm.js';
import 'SF/dashboard/student/help/StudentHelpWindow.js';
import 'SF/dashboard/student/history/HistoryPanel.js';
import 'SF/dashboard/advisor/AppointmentsPanel.js';
import 'SF/dashboard/advisor/CriticalItemsDetailsPanel.js';
import 'SF/dashboard/advisor/CriticalItemsPanel.js';
import 'SF/dashboard/advisor/DetailsPanel.js';
import 'SF/dashboard/advisor/ItemsListPanel.js';
import 'SF/dashboard/advisor/ScheduleFilterPanel.js';
import 'SF/dashboard/advisor/SchedulePanel.js';
import 'SF/dashboard/advisor/data/CriticalItemsStore.js';
import 'SF/dashboard/ActionPanel.js';
import 'SF/dashboard/ActiveConcernsPanel.js';
import 'SF/dashboard/CollapseWhenEmptyPlugin.js';
import 'SF/dashboard/CoursePriorityWindow.js';
import 'SF/dashboard/DelayedLoaderPlugin.js';
import 'SF/dashboard/EnhancedConfig.js';
import 'SF/dashboard/MeetingStore.js';
import 'SF/dashboard/MyInfoPanel.js';
import 'SF/dashboard/MyInfoPanelDataView.js';
import 'SF/dashboard/MyMessagesDetailsWindow.js';
import 'SF/dashboard/MyServicesPanel.js';
import 'SF/dashboard/RecentChangesPanel.js';
import 'SF/dashboard/StudentActionPanel.js';
import 'SF/dashboard/StudentSuccessScoreChart.js';
import 'SF/dashboard/StudentSuccessScoreDataView.js';
import 'SF/dashboard/StudentSuccessScores.js';
import 'SF/dashboard/StudentToDoDataView.js';
import 'SF/dashboard/TrackingChart.js';
import 'SF/dashboard/UpcomingAppointmentsPanel.js';
import 'SF/dashboard/Util.js';
